import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  box-sizing: border-box;
  max-height: 410px;
  margin: 0 40px;
  padding: 22px;
  border: 1px solid ${(props) => props.theme.colors.cardContainerEvolutiveCross};
  border-radius: 4px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  width: 100%;
  justify-content: space-between;
  gap: 0px 20px;
`;

export const SurveyCard = styled.div`
  display: flex;
  flex-direction: column;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  width: 50%;
  h2 {
    font-size: 14px;
    line-height: 16px;
    color: ${(props) => props.theme.colors.titleEvolutiveCross};
    margin: 8px 0;
  }
  label {
    display: flex;
    padding: 0 20px;
    font-size: 12px;
    line-height: 14px;
    color: ${(props) => props.theme.colors.labelFontColorEvolutiveCross};
    background-color: ${(props) => props.theme.colors.labelEvolutiveCross};
    border-radius: 6px;
    height: 42px;
    align-items: center;
  }
`;

export const ButtonShowQuestions = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px 12px;
  gap: 12px;
  width: 100%;
  height: 36px;
  margin-top: 55px;
  background-color: ${props => props.theme.colors.component};
  border: 1px solid ${(props) => props.theme.colors.borderButtonEvolutiveCross};
  border-radius: 4px;
  color: ${(props) => props.theme.colors.titleEvolutiveCross};
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  svg path {
      stroke: ${props => props.theme.colors.titleEvolutiveCross};
  }

  :hover {
    background-color: ${(props) => props.theme.colors.labelEvolutiveCross};
    font-weight: 700;
  }

  :active {
    background: ${props => props.theme.colors.component}; 
    font-weight: 400;
    color: ${props => props.theme.colors.secondary};

    svg path {
      stroke: ${props => props.theme.colors.secondary};
    }
  }
`;

export const ListCrossingQuestion = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  margin-top: 24px;
  gap: 24px 0px;
  padding-right: ${props => props.questionCrossed.length > 3 && '5px'};
  overflow-y: ${props => props.questionCrossed.length > 3 && 'scroll'};
`;

export const ItemCrossingQuestion = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  background: ${(props) => props.theme.colors.cardContainerEvolutiveCross};
  min-height: 40px;
  border-radius: 4px;
  label{
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: ${(props) => props.theme.card.listItemsTextColor};
    padding: 0px 20px;
  }
  span{
    display: block;
    width: 1px;
    height: 40px;
    background-color: ${(props) => props.theme.colors.borderButtonEvolutiveCross};
  }
`;
